import { useLanguage } from '../../contexts/LanguageContext';
import { useData } from '../../contexts/DataContext';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

const AboutDesktop = ({ about, language }) => {
  const { t } = useTranslation();
  const result = useData();
  const isRTL = language == 'ar' ? true : false;
  const isLargeScreen = useMediaQuery({ minWidth: 1440 });
  const isMediumScreen = useMediaQuery({ minWidth: 1024, maxWidth: 1439 });
  const isSmallScreen = useMediaQuery({ minWidth: 769, maxWidth: 1023 });
  const experienceYears = new Date().getFullYear() - about.years_experience;

  return (
    <div className="overflow-hidden relative py-12 text-gray-800 bg-white md:py-16 lg:py-24">
      <div className="absolute inset-0 bg-grid-gray/[0.05] bg-grid"></div>
      <div className="container relative px-4 mx-auto">
        <div className={`flex ${isSmallScreen ? 'flex-col gap-8' : 'gap-8 lg:gap-16'}`}>
          <div className={`space-y-6 lg:space-y-8 ${isSmallScreen ? 'w-full' : 'w-1/2'}`} data-aos="fade-right">
            <div className="inline-block px-4 py-2 text-gray-800 rounded-full">
              {about.title}
            </div>
            <h2 className={`${isLargeScreen ? 'text-5xl' : 'text-3xl lg:text-4xl'} font-bold leading-tight text-gray-800`}>
              {about.headline}<br />
              <span className="text-gray-800">{t('about.since')} {new Date().getFullYear() - about.years_experience}</span>
            </h2>
            <p className={`${isLargeScreen ? 'text-lg' : 'text-base'} leading-relaxed text-gray-800`}>
              {about.description}
            </p>
          </div>

          <div className={`relative ${isSmallScreen ? 'w-full' : 'w-1/2'}`} data-aos="fade-left">
            {/* Main Content Grid */}
            <div className="grid grid-cols-12 gap-6">
              {/* Main Image Section - Spans 8 columns */}
              <div className="col-span-12">
                <div className="relative">
                  <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                    <img
                      src={about.image_1}
                      alt="About Us"
                      className="w-full h-[350px] object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 via-transparent" />

                    {/* Stats Overlay */}
                    <div className="absolute bottom-0 left-0 right-0 p-8 grid grid-cols-3 gap-4 text-center">
                      <div className="text-white">
                        <div className="text-3xl font-bold mb-1">{about.years_experience}+</div>
                        <div className="text-sm opacity-80">{t('about.expereince')}</div>
                      </div>
                      <div className="text-white">
                        <div className="text-3xl font-bold mb-1">100%</div>
                        <div className="text-sm opacity-80">{t('about.clients')}</div>
                      </div>
                      <div className="text-white">
                        <div className="text-3xl font-bold mb-1">{experienceYears}</div>
                        <div className="text-sm opacity-80">{t('about.since')}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Countries Grid - Spans full width */}
              <div className="col-span-12">
                <div className="grid grid-cols-2 gap-4">
                  {about.countries.map((country, index) => (
                    <div
                      key={index}
                      className="flex items-center p-4 rounded-xl border transition-all duration-300 hover:shadow-md hover:border-gray-300 bg-white"
                    >
                      <div className="flex items-center gap-4">
                        <div className={`overflow-hidden w-12 h-12 rounded-full flex-shrink-0 ${isRTL ? 'ml-4' : ''}`}>
                          <img
                            src={`/assets/flags/${country.icon}.svg`}
                            alt={`${country.title} flag`}
                            className="object-cover w-full h-full"
                          />
                        </div>
                        <div>
                          <div className={`${isLargeScreen ? 'text-lg' : 'text-base'} font-semibold text-gray-800 truncate`}>
                            {country.title}
                          </div>
                          <div className="text-sm text-gray-600">{t('about.operating')}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutDesktop;